import { BillingSeatType } from '@heidi/schema/ml-scribe';
import type { UserBillingInfo } from '../../contracts';

/**
 * Any Max seat, whichever tier carries it: Clinician Max (`CLINICIAN_PRO` + MAX)
 * or Practice Max (`CLINICIAN_PRO_PLUS` + MAX). Overage behaviour (no send
 * lockout, complimentary banner, no upgrade nudge on a capped cycle) keys on the
 * seat alone, so this is what those surfaces read. `isClinicianMaxBillingSeat`
 * stays for the places that mean Clinician Max specifically.
 */
export function isMaxBillingSeat(
  billingInfo: Pick<UserBillingInfo, 'seat_type'> | null | undefined
): boolean {
  return billingInfo?.seat_type === BillingSeatType.MAX;
}
